<template>
  <div class="home_main"
       id="IndexNewDiv">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据总览</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!--<div class="row_msg_tip">停车场场库信息提示：用户月卡快到期！请及时充值！</div>-->
    <el-row>
      <div v-if="menuList.indexOf(221010)>-1">
        <div class="row_icon_tip">
          <div class="row">
            <div class="icon_theme_one"
                 v-bind:class="{icon_theme_active:!isOld}"
                 @click="hadnleSwitch(false)">今日收入</div>
            <div class="icon_theme_two"
                 v-bind:class="{icon_theme_active:isOld}"
                 @click="hadnleSwitch(true)">历史数据</div>
            <div class="block_search"
                 v-if="isOld">
              <span class="demonstration">开始日期：</span>
              <el-date-picker v-model="startTime"
                              type="date"
                              :clearable="false"
                              placeholder="选择日期">
              </el-date-picker>
              <span class="demonstration">结束日期：</span>
              <el-date-picker v-model="endTime"
                              type="date"
                              :clearable="false"
                              placeholder="选择日期">
              </el-date-picker>
              <el-button type="primary"
                         size="mini"
                         @click="queryHis"
                         icon="el-icon-search">查询</el-button>
            </div>
          </div>
          <div class="row row_card"
               v-if="!isOld">
            <div class="card_item left_margin_left_10 card_item_one">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_one.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">今应收金额</p>
                  <h2 class="card_number">{{fCalcAmt}}</h2>
                  <p class="card_line"></p>
                  <p>较昨日同时刻 {{fCalcAmtRate}}</p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_two">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_two.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">今实收金额</p>
                  <h2 class="card_number">{{fPayAmount}}</h2>
                  <p class="card_line"></p>
                  <p>较昨日同时刻 {{fPayAmountRate}}</p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_three">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_three.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">今支付笔数</p>
                  <h2 class="card_number">{{fPayCnt}} <span>笔</span></h2>
                  <p class="card_line"></p>
                  <p>较昨日同时刻 {{fPayCntRate}}</p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_four">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_four.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">今优惠金额</p>
                  <h2 class="card_number">{{fDedAmt}}</h2>
                  <p class="card_line"></p>
                  <p>较昨日同时刻 {{fDedAmtRate}}</p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_five">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_five.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">今优惠笔数</p>
                  <h2 class="card_number">{{fCouPayCnt}} <span>笔</span></h2>
                  <p class="card_line"></p>
                  <p>较昨日同时刻 {{fCouPayCntRate}}</p>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="row row_card"
               v-else>
            <div class="card_item left_margin_left_10 card_item_one">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_one.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">应收金额</p>
                  <h2 class="card_number">{{fCalcAmtHis}}</h2>
                  <p class="card_line"></p>

                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_two">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_two.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">实收金额</p>
                  <h2 class="card_number">{{fPayAmountHis}}</h2>
                  <p class="card_line"></p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_three">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_three.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">支付笔数</p>
                  <h2 class="card_number">{{fPayCntHis}} <span>笔</span></h2>
                  <p class="card_line"></p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_four">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_four.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">优惠金额</p>
                  <h2 class="card_number">{{fDedAmtHis}}</h2>
                  <p class="card_line"></p>
                </el-col>
              </el-row>
            </div>
            <div class="card_item left_margin_left_20 card_item_five">
              <el-row>
                <el-col :span="8"
                        style="text-align:right">
                  <img src="../../assets/images/icon_five.png" />
                </el-col>
                <el-col :span="16">
                  <p class="card_msg">优惠笔数</p>
                  <h2 class="card_number">{{fCouPayCntHis}} <span>笔</span></h2>
                  <p class="card_line"></p>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="row_table"
             v-if="!isOld">
          <div class="table_form_search">
            <span>全部车库</span>
            <!--<i slot="prefix" class="search el-input__icon el-icon-search" @click="queryPark" ></i>-->
            <!--<input type="text"-->
            <!--class="search"-->
            <!--v-model="fParkName"-->
            <!--placeholder="搜索"  />-->
            <el-input class="vuesearch"
                      placeholder="请输入内容"
                      v-model="fParkName">
              <i slot="prefix"
                 class="el-input__icon el-icon-search"
                 @click="queryPark"></i>
            </el-input>
          </div>
          <el-table :height="tableHeight"
                    :data="tableParkData"
                    style="padding-right:20px;padding-left:20px;width: 100%">
            <el-table-column prop="fParkName"
                             label="场库名称"
                             width="180">
              <template slot-scope="scope">
                <img src="../../assets/images/wifi.png"
                     class="cellImage"
                     v-if="scope.row.mqStatus" />
                <img src="../../assets/images/wifi-notactivated.png"
                     class="cellImage"
                     v-else />
                <span style="margin-left: 10px">{{ scope.row.fParkName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fCalcAmt"
                             align="right"
                             label="今日应收金额（元）">
            </el-table-column>
            <el-table-column prop="fPayAmount"
                             align="right"
                             label="今日实收金额（元）">
            </el-table-column>
            <el-table-column prop="fPayCnt"
                             align="right"
                             width="100"
                             label="支付笔数">
            </el-table-column>
            <el-table-column prop="fDedAmt"
                             align="right"
                             label="优惠金额">
            </el-table-column>
            <el-table-column prop="ffreeCnt"
                             align="right"
                             width="100"
                             label="优惠笔数">
            </el-table-column>
            <el-table-column prop="fOpenCnt"
                             align="right"
                             label="免费开闸次数">
            </el-table-column>
            <el-table-column prop="PCRate"
                             align="right"
                             label="饱和度">
            </el-table-column>
            <!--<el-table-column-->
            <!--prop="address"-->
            <!--label="操作">-->
            <!--</el-table-column>-->
            <el-table-column label="操作"
                             align="center"
                             width="140">
              <template slot-scope="scope">
                <el-button size="mini"
                           type="success"
                           @click="detailInfo(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="background: #f4f2fc;height: 20px">
            <span></span>
          </div>
        </div>
        <div class="row_table"
             v-else>
          <div class="table_form_search">
            <span>历史数据</span>
          </div>
          <div class="row">
            <el-col :span="14">
              <el-table :height="tableHeight"
                        :data="tableHisParkData"
                        style="padding-left:20px;padding-bottom:20px;width: 100%">
                <el-table-column prop="fParkName"
                                 label="场库名称"
                                 width="180">
                </el-table-column>
                <el-table-column prop="fCalcAmt"
                                 align="right"
                                 label="应收金额（元）">
                </el-table-column>
                <el-table-column prop="fPayAmount"
                                 align="right"
                                 label="实收金额（元）">
                </el-table-column>
                <el-table-column prop="fPayCnt"
                                 align="right"
                                 label="支付笔数">
                </el-table-column>
                <el-table-column prop="fDedAmt"
                                 align="right"
                                 label="优惠金额">
                </el-table-column>
                <el-table-column prop="ffreeCnt"
                                 align="right"
                                 label="优惠笔数">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="10">
              <div id="echar_main_bar"
                   style="width: 100%;height: 300px;padding-left:20px;"></div>
            </el-col>
            <div style="clear: both"></div>
          </div>
          <div class="row"
               style="background: #f4f2fc;height: 20px">
            <span></span>
          </div>
        </div>
      </div>
      <el-row v-else>
        <el-col style="text-align:center">
          <i class="web-font">欢迎来到停车云平台管理系统</i>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { statistics as api } from '../../api/statistics'
// 引入 ECharts 主模块
import * as echarts from 'echarts'
import * as user from '../../api/user'
export default {
  data () {
    return {
      menuList: [],
      data: [
        { value: 0, name: '应收金额', itemStyle: { normal: { color: '#3F95E6' } } },
        { value: 0, name: '实收金额', itemStyle: { normal: { color: '#E4933F' } } },
        { value: 0, name: '优惠金额', itemStyle: { normal: { color: '#E94151' } } },
        { value: 0, name: '支付笔数', itemStyle: { normal: { color: '#7F3FE4' } } },
        { value: 0, name: '优惠笔数', itemStyle: { normal: { color: '#E43E96' } } }
      ],
      tableHisParkData: [],
      tableParkData: [],
      tableHeight: 0,
      fParkName: '',
      fCalcAmt: 0,
      fCalcAmtRate: '',
      fPayAmount: 0,
      fPayAmountRate: '',
      fPayCnt: 0,
      fPayCntRate: '',
      fDedAmt: 0,
      fDedAmtRate: '',
      fCouPayCnt: 0,
      fCouPayCntRate: '',
      fCalcAmtHis: 0,
      fPayAmountHis: 0,
      fPayCntHis: 0,
      fDedAmtHis: 0,
      fCouPayCntHis: 0,
      isOld: false,
      startTime: '',
      endTime: ''
    }
  },
  methods: {
    detailInfo (row) {
      this.$router.push('/indexDetail?fCustID=' + row.fCustID + '&fParkID=' + row.fParkID)
    },
    queryHis () {
      var startTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      var endTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      api.getHisStat({ 'startTime': startTime, 'endTime': endTime }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.fCalcAmtHis = data.Data.fCalcAmt
            this.fPayAmountHis = data.Data.fPayAmount
            this.fPayCntHis = data.Data.fPayCnt
            this.fDedAmtHis = data.Data.fDedAmt
            this.fCouPayCntHis = data.Data.fCouPayCnt
            this.data[0].value = this.fCalcAmtHis
            this.data[1].value = this.fPayAmountHis
            this.data[2].value = this.fDedAmtHis
            this.data[3].value = this.fPayCntHis
            this.data[4].value = this.fCouPayCntHis
            setTimeout(() => { this.initEcharExce() }, 0)
          } else {
            this.$message.error(data.Msg || '提示：只能查询近一个月的历史数据')
          }
        }
      })
      this.queryHisPark()
    },
    queryHisPark () {
      var startTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      var endTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      api.getHisParkStat({ 'startTime': startTime, 'endTime': endTime }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.tableHisParkData = data.Data || []
          }
        }
      })
    },
    queryPark () {
      var fparkName = this.fParkName
      api.getTodayParkStat({ 'fParkName': fparkName }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.tableParkData = data.Data || []
          }
        }
      })
    },
    hadnleSwitch (isOld) {
      this.isOld = isOld
      if (this.isOld) {
        this.queryHis()
        // setTimeout(() => { this.initEcharExce() }, 0)
        // this.$nextTick(() => {
        //   this.initEchar('echar_main_bar')
        // })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 590
      obj.tableHeight = clientHeight
    },
    initEcharExce () {
      this.initEchar('echar_main_bar')
    },
    initEchar (name) {
      var chartDom = document.getElementById(name)
      if (!chartDom) {
        return
      }
      var myChart = echarts.init(chartDom)
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (params.dataIndex === 0 || params.dataIndex === 1 || params.dataIndex === 2) {
              return params.name + ' ：' + params.value + '元'
            } else {
              return params.name + ' ：' + params.value + '笔'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: ['应收金额', '实收金额', '优惠金额', '支付笔数', '优惠笔数'],
          name: '停车场'
        },
        yAxis: {
          type: 'value',
          name: '金额',
          axisLine: {
            show: true
          },
          boundaryGap: false,
          splitLine: {
            show: false
          }
        },
        // series: data
        series: [
          {
            itemStyle: {
              normal: {
                barBorderRadius: [50, 50, 0, 0]
              }
            },
            // label: {
            //   show: true,
            //   position: 'top'
            // },
            data: this.data,
            type: 'bar',
            barWidth: '20%'
          }
        ]
      }
      myChart.setOption(option)
      var newHeight = this.tableHeight
      myChart.resize({ height: newHeight })
    }
  },
  mounted () {
    var today = new Date()
    today.setDate(today.getDate() - 2)
    this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    today = new Date()
    today.setDate(today.getDate() - 1)
    this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    api.getTodayStat().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.fCalcAmt = data.Data.fCalcAmt
          this.fCalcAmtRate = data.Data.fCalcAmtRate
          this.fPayAmount = data.Data.fPayAmount
          this.fPayAmountRate = data.Data.fPayAmountRate
          this.fPayCnt = data.Data.fPayCnt
          this.fPayCntRate = data.Data.fPayCntRate
          this.fDedAmt = data.Data.fDedAmt
          this.fDedAmtRate = data.Data.fDedAmtRate
          this.fCouPayCnt = data.Data.fCouPayCnt
          this.fCouPayCntRate = data.Data.fCouPayCntRate
        }
      }
    })
    this.queryPark()
    this.queryHis()
    window.onresize = () => {
      this.setTableHeight(this)
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 0 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.menuList = data.Data.data || []
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style  scoped>
h3.tip {
  margin: 0px;
}
.cellImage {
  width: 14px;
  height: 11px;
}
.home_main {
  /*padding: 10px;*/
  /*background-color: #dddbe8;*/
  /*position: relative;*/
  /*left: -20px;*/
  /*top: -20px;*/
  /*background-color: #0a67fb;*/
}
.row_msg_tip {
  padding: 15px 0px;
  text-align: center;
  background: #efedf8;
  border-radius: 5px;
  color: #5a595d;
}
.row_icon_tip {
  background: #efedf8;
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}
.icon_theme_one,
.icon_theme_two {
  padding: 10px 25px;
  margin: 10px;
  background: #eae8f2;
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
}
.icon_theme_active {
  background: #3d84e1;
  color: #ffffff;
}
.row_card {
  display: flex;
  align-items: center;
  padding-bottom: 40px;
}

.row_card .card_item {
  width: calc((100% - 100px) / 5);
  height: 160px;
  border-radius: 5px;
  color: #ffffff;
}
.card_item_one {
  background-image: linear-gradient(to right, #43a8ec, #3d85e1);
  box-shadow: 15px 15px #c1d2f2;
}
.card_item_two {
  background-image: linear-gradient(to right, #3dc2d9, #38a0ce);
  box-shadow: 15px 15px #c0d9ed;
}
.card_item_three {
  background-image: linear-gradient(to right, #51cb7a, #4cc187);
  box-shadow: 15px 15px #c5e2db;
}
.card_item_four {
  background-image: linear-gradient(to right, #ef8363, #e6945f);
  box-shadow: 15px 15px #edd6d0;
}
.card_item_five {
  background-image: linear-gradient(to right, #42a9ec, #3d85e1);
  box-shadow: 15px 15px #c1d2f2;
}
.left_margin_left_10 {
  margin-left: 10px;
}
.left_margin_left_20 {
  margin-left: 20px;
}
.left_margin_right_10 {
  margin-right: 10px;
}
.card_item img {
  width: 100px;
  height: 100px;
}
.card_item .card_msg {
  margin-top: 20px;
  margin-bottom: 0px;
  font-size: 20px;
}
.card_item .card_number {
  margin-top: 10px;
  margin-bottom: 10px;
}
.card_item .card_number > span {
  font-size: 14px;
}
.card_item .card_line {
  border: 0.5px solid rgba(252, 249, 249, 0.2);
  margin-right: 20px;
}
.row_table {
  background: #f4f2fc;
  border-radius: 5px;
  margin-top: 20px;
}
.row_table .table_form_search {
  background: #f4f2fc;
}
.row_table .table_form_search > span {
  display: inline-block;
  padding: 20px 30px;
}
.row_table .table_form_search > .search {
  float: right;
  margin: 15px 10px;
  width: 300px;
  height: 30px;
  border: 1px solid #dedce5;
  outline: none;
  border-radius: 15px;
  line-height: 30px;
  padding-left: 30px;
  background: url("../../assets/images/search.png") no-repeat 8px 10px;
}

.table_view {
  width: 100%;
  padding: 20px;
}
/* .table_view thead > tr {
  display: flex;
  justify-content: center;
  align-items: center;
} */
.table_view thead > tr > td {
  padding: 10px 0px;
  text-align: center;
  width: calc(100% / 10);
}
.table_view thead > tr > td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.table_view thead > tr > td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.table_view thead > tr > td:nth-child(2n-1) {
  background: #dde5f6;
}
.table_view thead > tr > td:nth-child(2n) {
  background: #e6e9f7;
}
.table_view tbody > tr {
  background: #f5f4fb;
  margin: 10px 0px;
}
.table_view tbody > tr > td {
  text-align: center;
  padding: 10px 0px;
}
.color1 {
  color: #72adeb;
}
.color2 {
  color: #6fc1de;
}
.color3 {
  color: #7bd09d;
}
.color4 {
  color: #87a5ee;
}
.color5 {
  color: #79bde1;
}
.block_search {
  float: right;
  margin-top: 10px;
}
.el-table th {
  /* background-color: #1a72c1 !important;*/
  background-color: red !important;
}
</style >

<style>
/*#IndexNewDiv .row_table .el-table  thead > tr > th {*/
/*background: #f4f2fc;*/
/*border-radius: 5px;*/
/*}*/
#IndexNewDiv .row_table .el-table thead > tr > th {
  padding: 10px 0px !important;
  text-align: center !important;
  width: calc(100% / 10) !important;
}
/*#IndexNewDiv .row_table .el-table  thead > tr > td:first-child {*/
/*padding: 10px 0px !important;*/
/*text-align: left !important;*/
/*width: calc(100% / 10) !important;*/
/*}*/
/*#IndexNewDiv .row_table .el-table  thead > tr > th:first-child {*/
/*border-top-left-radius: 10px !important;*/
/*border-bottom-left-radius: 10px !important;*/
/*}*/
/*#IndexNewDiv .row_table .el-table  thead > tr > th:last-child {*/
/*border-top-right-radius: 10px !important;*/
/*border-bottom-right-radius: 10px !important;*/
/*}*/
#IndexNewDiv .row_table .el-table thead > tr > th:nth-child(2n-1) {
  background: #dde5f6 !important;
}
#IndexNewDiv .row_table .el-table thead > tr > th:nth-child(2n) {
  background: #e6e9f7 !important;
}
#IndexNewDiv .el-table,
.el-table__expanded-cell {
  background-color: #f4f2fc;
}
#IndexNewDiv .row_table .el-table td:first-child {
  background: #f4f2fc !important;
  padding-bottom: 10px !important;
  padding-bottom: 10px !important;
  text-align: left !important;
  /*border-radius: 5px;*/
}
#IndexNewDiv .row_table .el-table td:nth-child(2) {
  color: #72adeb;
}
#IndexNewDiv .row_table .el-table td:nth-child(3) {
  color: #6fc1de;
}
#IndexNewDiv .row_table .el-table td:nth-child(4) {
  color: #7bd09d;
}
#IndexNewDiv .row_table .el-table td:nth-child(5) {
  color: #87a5ee;
}
#IndexNewDiv .row_table .el-table td:nth-child(6) {
  color: #79bde1;
}
/*#IndexNewDiv .row_table .el-table td:not(first-child) {*/
/*background: #f4f2fc !important;*/
/*padding-bottom: 10px  !important;*/
/*padding-bottom: 10px !important;*/
/*text-align: right !important;*/
/*!*border-radius: 5px;*!*/
/*}*/
#IndexNewDiv .row_table .el-table td {
  background: #f4f2fc !important;
  padding-bottom: 10px !important;
  padding-bottom: 10px !important;
  text-align: center !important;
  /*border-radius: 5px;*/
}
#IndexNewDiv .row_table .table_form_search > .vuesearch {
  float: right;
  margin: 15px 10px;
  width: 300px;
  height: 30px !important;
  border: 1px solid #dedce5;
  outline: none;
  border-radius: 15px;
  line-height: 30px;
  padding-left: 30px;
}
#IndexNewDiv .row_table .table_form_search .el-input--prefix .el-input__inner {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
#IndexNewDiv .row_table .table_form_search .el-input--prefix .el-input__inner {
  font-family: 微软雅黑;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  width: 300px;
  border: 0px solid #dedce5;
  background-color: #f4f2fc;
  /*border-radius: 15px;*/
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/home/indexNew.vue